import { makeStyles } from "@material-ui/core";

export const FPAroveedoresTerrestresStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    dialogContent: {
        height: "70vh", 
        maxHeight: '600px', 
        overflowY: 'scroll'
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "500px",
        maxWidth: "75rem",
        width: "90%",
    },
    tabPanel: {
        maxWidth: "720px", 
        width: "100%"
    },
    boxContainer: {
        border: `1px solid ${theme.palette.primary.main}`,
        height: "400px",
        overflowY: "auto",
        padding: "1rem",
    }
}))